import { IPaginationParams } from '../global/pagination';
import { ISortParams } from '../global/sort';

export interface IWebhookEvents {
  id: number;
  journeyId: number;
  type: string;
  recipientId: number;
  created: string;
  aborted: string;
  acknowledged: string;
  tries: number;
  payload: string;
}

export interface IWebhookEventsRequestParams extends IPaginationParams, ISortParams {
  partnerId?: number;
  type?: string;
  journeyId?: number;
  transferCompanyId?: number;
}

export enum WebhookEventsType {
  TransferCompany = 'TRANSFER_COMPANY',
  Partner =  'PARTNER',
}

export const WebhookEventsTypeDisplayName = {
  [WebhookEventsType.TransferCompany]: 'Transfer company',
  [WebhookEventsType.Partner]: 'Partner',
}